/* unplugin-vue-components disabled */import { render } from "./prompts-list.vue?vue&type=template&id=c091e79e&scoped=true"
import script from "./prompts-list.vue?vue&type=script&lang=js"
export * from "./prompts-list.vue?vue&type=script&lang=js"

import "./prompts-list.vue?vue&type=style&index=0&id=c091e79e&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c091e79e"],['__file',"src/components/prompts-v2/prompts-list.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c091e79e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c091e79e', __exports__)) {
    api.reload('c091e79e', __exports__)
  }
  
  module.hot.accept("./prompts-list.vue?vue&type=template&id=c091e79e&scoped=true", () => {
    api.rerender('c091e79e', render)
  })

}


export default __exports__